<app-modal-wrapper [title]="'Edit artist info' | translate" (closeAction)="close()">
  <form
    modalBody
    *ngIf="artistUploadData.formGroup"
    [formGroup]="artistUploadData.formGroup"
    vgFocusFirstInvalid
    [form]="artistUploadData.formGroup"
    (ngSubmit)="onSubmit()"
  >
    <div class="form-group">
      <label for="artistName">{{ 'feature.artist.artist_name' | translate }}</label>
      <input
        type="text"
        class="form-control"
        id="artistName"
        [placeholder]="('Enter' | translate) + ' ' + ('Artist Name' | translate)"
        formControlName="name"
      />
      <vg-error-section [label]="'Artist Name' | translate" [group]="artistUploadData.formGroup" controlName="name"></vg-error-section>
    </div>
    <div class="form-group">
      <label for="birthDate">{{ 'BirthDate' | translate }}</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="dd/MM/yyyy"
          id="birthDate"
          name="dp"
          ngbDatepicker
          #d="ngbDatepicker"
          formControlName="birthDate"
          [minDate]="minDate"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
            <i class="bi bi-calendar3"></i>
          </button>
        </div>
      </div>
      <vg-error-section [label]="'BirthDate' | translate" [group]="artistUploadData.formGroup" controlName="birthDate"></vg-error-section>
    </div>
    <label for="avatar">{{ 'Avatar' | translate }}</label>
    <div class="form-group">
      <vg-file-input
        id="avatar"
        formControlName="avatarUrl"
        [remoteFileType]="'image'"
        [formData]="artistUploadData.formData"
        [formDataFilePart]="'avatar'"
      ></vg-file-input>
    </div>
    <div class="form-group">
      <label for="biography">Tiểu sử</label>
      <textarea class="form-control" id="biography" formControlName="biography" [rows]="5"></textarea>
    </div>
    <vg-upload-progress [httpObs]="artistUploadData.observable" (successEvent)="onUpdateSuccess($event)"></vg-upload-progress>
  </form>
  <ng-container modalFooter>
    <button type="submit" ngbAutofocus class="btn btn-primary mr-2" (click)="onSubmit()">{{ 'common.button.save' | translate }}</button>
    <button class="btn btn-secondary" (click)="close()">{{ 'common.button.cancel' | translate }}</button>
  </ng-container>
</app-modal-wrapper>
